/**
 * The Product Selection handoff (architecture §2.4/§2.5). Logged-in →
 * straight into the wizard at the Details step (StepOccasion/StepTemplate
 * skipped, per §2.5's decision) with the Collection's Template already
 * applied. Logged-out → /login, selection preserved via
 * `pendingSelection.ts` and resumed by `Login.tsx` after sign-in.
 */
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/src/modules/auth/AuthProvider';
import { setPendingCatalogSelection } from './pendingSelection';
import type { Collection } from './types';

export function useSelectProduct() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (product: Collection) => {
    const { id, templateId, template } = product;
    const occasionType = template.occasionType;

    if (!user) {
      setPendingCatalogSelection({ productId: id, templateId, occasionType });
      navigate('/login');
      return;
    }

    navigate('/wizard', {
      state: { initialStep: 3, templateId, occasionType },
    });
  };
}
